import React, { useState } from "react";
import styled from "styled-components";
import { ModelCreatorForm } from "./ModelCreatorForm";
import type {
  LocaleYearMakeData,
  ModelCreateRequest,
  SearchResponse
} from "@dealer-center/inventory-pages-gvm-interface";
import { useModelCreate } from "@dealer-center/inventory-pages-gvm-fetch";

const StyledModelCreatorPage = styled.div`
  padding-left: 10px;
  padding-top: 10px;
  width: 100%;
  z-index: 999;
`;

type ModelCreatorPageProps = SearchResponse<LocaleYearMakeData>;

export const ModelCreatorPage = (props: ModelCreatorPageProps) => {
  const [modelCreateRequest, setModelCreateRequest] =
    useState<ModelCreateRequest>({ locale: "US_EN" });
  const createModelMutation = useModelCreate();

  const render = () => {
    return (
      <StyledModelCreatorPage>
        <ModelCreatorForm
          createModelMutation={createModelMutation}
          localeYearMakeSearchResponse={props}
          modelCreateRequest={modelCreateRequest}
          setModelCreateRequest={setModelCreateRequest}
        />
      </StyledModelCreatorPage>
    );
  };

  return render();
};
